export const whatsappHref = 'https://wa.me/5493416049035';

// Link de WhatsApp con el primer mensaje ya escrito. Si hay una promo vigente
// la nombra, así sabemos que viene de la campaña sin preguntar.
export const mensajeWhatsappSitio = (promo = promoVigente()) =>
  promo
    ? `¡Hola! Vi la promo "${promo.etiqueta}" y quiero que me muestren Impulza.`
    : '¡Hola! Quiero que me muestren Impulza.';

export const whatsappMensajeHref = (texto = mensajeWhatsappSitio()) =>
  texto ? `${whatsappHref}?text=${encodeURIComponent(texto)}` : whatsappHref;

// Meta Pixel: un clic a WhatsApp cuenta como "Contact". Sin esto, quien
// prefiere escribir en vez de completar el formulario no aparece en Ads Manager.
export const trackWhatsappClick = (origen) => {
  try {
    if (typeof window !== 'undefined' && window.fbq) window.fbq('track', 'Contact', { content_name: origen });
  } catch {
    // El píxel nunca debe frenar la navegación.
  }
};

// El embudo de demo en video queda "apagado" hasta que exista al menos un
// video grabado (algún videoUrl con valor en demoVideos). Mientras tanto el
// sitio no muestra nav, secciones ni ruta /demo; al cargar el primer link,
// todo aparece solo, sin tocar más código.
export const hasPublishedDemoVideos = () => demoVideos.some((video) => Boolean(video.videoUrl));

// Videos demo por circuito. Cuando exista el video grabado, completar `videoUrl`
// con el link de YouTube (watch o youtu.be) o un .mp4 y la card lo reproduce
// embebida. Mientras videoUrl sea null, la card muestra el poster con estado
// "próximamente" y deriva al pedido de demo.
export const demoVideos = [
  {
    id: 'mostrador',
    circuit: 'Ventas y facturación',
    title: 'Cobrar y facturar sin frenar la fila',
    duration: '90 seg',
    description:
      'Una venta real de punta a punta: escaneás el producto, cobrás mitad tarjeta mitad efectivo y el comprobante sale en el mismo paso.',
    videoUrl: null,
    imageKey: 'ventas',
  },
  {
    id: 'stock',
    circuit: 'Compras y stock',
    title: 'Cargar una compra con una foto',
    duration: '75 seg',
    description:
      'Le sacás una foto a la factura del proveedor y el escáner IA convierte todo en artículos, cantidades y costos. El stock queda al día solo.',
    videoUrl: null,
    imageKey: 'stock',
  },
  {
    id: 'cierre',
    circuit: 'Caja y cierre',
    title: 'Cerrar el día sin papelitos',
    duration: '60 seg',
    description:
      'Arqueo por turno con efectivo, tarjetas, billeteras y transferencias separados. Las diferencias aparecen antes de que se conviertan en pérdidas.',
    videoUrl: null,
    imageKey: 'dashboard',
  },
  {
    id: 'tienda',
    circuit: 'Tienda online',
    title: 'Vender online con el mismo stock del local',
    duration: '75 seg',
    description:
      'El catálogo web y el mostrador comparten inventario en tiempo real: se vende una prenda en el local y desaparece de la tienda al instante.',
    videoUrl: null,
    imageKey: 'tiendaRopa',
  },
  {
    id: 'produccion',
    circuit: 'Producción y recetas',
    title: 'Saber cuánto te cuesta cada plato',
    duration: '90 seg',
    description:
      'Cargás la receta una vez y cada producción descuenta insumos y calcula el costo real. Cocina y caja hablan el mismo idioma.',
    videoUrl: null,
    imageKey: 'produccion',
  },
  {
    id: 'finanzas',
    circuit: 'Flujo de fondos',
    title: 'Ver cuánta plata vas a tener el mes que viene',
    duration: '90 seg',
    description:
      'Cobros, pagos y bancos proyectados hacia adelante: sabés qué semanas vienen ajustadas antes de que lleguen.',
    videoUrl: null,
    imageKey: 'finanzas',
  },
];

// ---------- Promoción vigente del sitio ----------
// Las fechas van con offset de Argentina (-03:00). Fuera de rango no se muestra
// nada: la promo se apaga sola el día siguiente al cierre, aunque nadie toque
// el código. Si dos se superponen, gana la primera de la lista (por eso el
// CyberMonday va antes que el Pack).
export const PRECIO_IMPLEMENTACION = '150.000';

export const promos = [
  {
    id: 'cyber-2026',
    desde: '2026-11-02T00:00:00-03:00',
    hasta: '2026-11-04T23:59:59-03:00',
    etiqueta: 'CyberMonday',
    texto: 'Implementación gratis aunque pagues mes a mes',
    detalle: 'Solo hasta el 4/11',
    faq: 'Del 2 al 4 de noviembre (CyberMonday) es gratis aunque pagues mes a mes.',
  },
  {
    id: 'pack-arranque-2026',
    desde: '2026-10-15T00:00:00-03:00',
    hasta: '2026-11-30T23:59:59-03:00',
    etiqueta: 'Pack de arranque',
    texto: `Pagando los 3 primeros meses juntos, la implementación ($${PRECIO_IMPLEMENTACION}) es gratis`,
    detalle: 'Hasta el 30/11',
    faq: 'Hasta el 30 de noviembre es gratis si pagás los 3 primeros meses juntos.',
  },
];

export const promoVigente = (now = new Date()) =>
  promos.find((promo) => now >= new Date(promo.desde) && now <= new Date(promo.hasta)) || null;

// ---------- Origen de cada lead (UTM) ----------
// Se guarda al entrar al sitio y se lee al enviar el formulario de demo, porque
// el visitante casi nunca llega directo a /pedir-demo: entra a la home con los
// UTM y navega. Regla: una visita con UTM pisa lo guardado (último clic
// atribuible); una visita sin UTM no pisa nada (navegación interna).
const ATTRIBUTION_KEY = 'impulza_attribution_v1';
const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

// ---------- Referidos de contadores (?ref=codigo) ----------
// El link que reparte cada estudio contable lleva ?ref=<codigo>. Se guarda
// aparte de los UTM y en localStorage: una visita posterior con UTM (un anuncio)
// no le saca el referido al estudio, y el cliente puede volver otro día.
// Vence a los 90 días; un ref nuevo pisa al anterior.
const REFERRAL_KEY = 'impulza_ref_v1';
const REFERRAL_TTL_MS = 90 * 24 * 60 * 60 * 1000;
const REFERRAL_PATTERN = /^[a-z0-9-]{1,40}$/;

export const normalizeReferralCode = (value) => {
  const code = String(value || '').trim().toLowerCase();
  return REFERRAL_PATTERN.test(code) ? code : '';
};

const captureReferral = (params) => {
  const code = normalizeReferralCode(params.get('ref'));
  if (!code) return;
  try {
    window.localStorage.setItem(REFERRAL_KEY, JSON.stringify({ code, at: Date.now() }));
  } catch {
    // Storage bloqueado: el lead entra igual, sin referido.
  }
};

const getReferral = () => {
  try {
    const stored = JSON.parse(window.localStorage.getItem(REFERRAL_KEY) || 'null');
    if (!stored?.code || !stored?.at || Date.now() - stored.at > REFERRAL_TTL_MS) return '';
    return normalizeReferralCode(stored.code);
  } catch {
    return '';
  }
};

export const captureAttribution = (search = '', pathname = '/') => {
  try {
    const params = new URLSearchParams(search);
    captureReferral(params);
    const utm = {};
    UTM_KEYS.forEach((key) => {
      const value = params.get(key);
      if (value) utm[key] = value.slice(0, 120);
    });
    const hasUtm = Object.keys(utm).length > 0;
    if (!hasUtm && window.sessionStorage.getItem(ATTRIBUTION_KEY)) return;

    const referrer = document.referrer || '';
    const external = referrer && !referrer.includes(window.location.host);
    window.sessionStorage.setItem(
      ATTRIBUTION_KEY,
      JSON.stringify({
        ...utm,
        landing_path: String(pathname || '/').slice(0, 200),
        referrer: external ? referrer.slice(0, 300) : null,
      }),
    );
  } catch {
    // sessionStorage bloqueado (modo privado, webview): el lead entra igual, sin origen.
  }
};

export const getAttribution = () => {
  try {
    const stored = JSON.parse(window.sessionStorage.getItem(ATTRIBUTION_KEY) || '{}') || {};
    const clean = {};
    [...UTM_KEYS, 'landing_path', 'referrer'].forEach((key) => {
      if (stored[key]) clean[key] = String(stored[key]);
    });
    const referral = getReferral();
    if (referral) clean.referido_por = referral;
    return clean;
  } catch {
    return {};
  }
};
